import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter, Routes, Route} from 'react-router-dom'
import Home from './Pages/Home';
import Contact from './Pages/Contact';
import Menu from './Pages/Menu';
import SignUp from './Pages/SignUp';
import SignIn from './Pages/sign_in';
import AdminMenu from './Pages/Admin/AdminMenu';
import EditMenu from './Pages/Admin/EditMenu';
import Item from './Pages/Item';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route/>

        <Route path='admin' element={<AdminMenu/>}>
          <Route path='edit' element={<EditMenu/>}/>
        </Route>
        <Route path='sign-up' element={<SignUp/>}/>
        <Route path='sign-in' element={<SignIn/>}/>
        <Route path='' element={<App/>}>
          <Route path='' element={<Home/>}/>
         
          <Route path='menu' element={<Menu/>}>
            <Route path='item' element={<Item/>}/>
          </Route>
          <Route path='contact' element={<Contact/>}/>
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
